import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  profileSettingsTitle: {
    id: "more.general.profileSettingsTitle",
    defaultMessage: "Profile Settings"
  },
  guideColigoTitle: {
    id: "more.general.guideColigoTitle",
    defaultMessage: "Guide to coligo"
  },
  reportIssueTitle: {
    id: "more.general.reportIssueTitle",
    defaultMessage: "Report an Issue"
  },
  loadingTitle: {
    id: "more.general.loadingTitle",
    defaultMessage: "Loading..."
  },
  logoutTitle: {
    id: "more.general.logoutTitle",
    defaultMessage: "Logout"
  },
  versionText: {
    id: "more.general.versionText",
    defaultMessage: "Version"
  },
  chooseChildText: {
    id: "more.general.chooseChildText",
    defaultMessage: "Choose one of your Children"
  },
  previewFileErrorMsg: {
    id: "more.general.previewFileErrorMsg",
    defaultMessage: "A problem occurred while previewing the file, please try again later"
  },
  previewErrorTitle: {
    id: "more.general.previewErrorTitle",
    defaultMessage: "Preview Error"
  }
});